import { Alert, Grid, ListItemText, MenuItem, TextField } from '@mui/material';
import useRequest from 'hooks/useRequest';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EventService from 'services/api/EventService';
import SelectOption from 'store/types/SelectOption';
import { FormProps, getValidationProps } from 'util/Form';
import { defaultGridItemProps, getInputLoadingProps } from 'util/Layout';

import commonStyles from 'styles/common.module.scss';

interface EventAgeFormItemProps extends FormProps {
  required?: boolean;
}

const EventAgeFormItem: React.FunctionComponent<EventAgeFormItemProps> = ({ fieldName = 'age', required }) => {
  const { data, loading, error } = useRequest<SelectOption[] | null>(EventService.getEventAgeRanges);
  const options = data ?? [];
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return error ? (
    <Alert severity={'error'} className={commonStyles.alert}>
      {error}
    </Alert>
  ) : (
    <Grid {...defaultGridItemProps}>
      <h3 className={commonStyles.subTitle}>{'Age Range'}</h3>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            {...getValidationProps(fieldName, errors)}
            InputProps={getInputLoadingProps(loading)}
            disabled={loading}
            required={required}
            select={true}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selectedId: unknown) =>
                options.find(({ id }) => id === selectedId)?.name || <span>{'All Ages'}</span>,
            }}
          >
            <MenuItem value={''}>
              <ListItemText primary={'All Ages'} />
            </MenuItem>
            {options.map(({ id, name }) => (
              <MenuItem value={id} key={`eventAge-${id}`}>
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </Grid>
  );
};

export default EventAgeFormItem;
